import React, { useReducer } from "react";
import { AuthContext } from "./auth/authContext";
import { authReducer } from "./auth/authReducer";
import { Routes } from "./routes/Routes";

import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';


const init = () => {
    return {
        logged: true,
        name: 'Usuario Temporal'
    }

}

function App() {

    
    const [ user, dispatch ] = useReducer( authReducer , {}, init )
    return (
        <LocalizationProvider dateAdapter={ AdapterDateFns }>

            <AuthContext.Provider value={{
                user,
                dispatch
            }}>
                <Routes/>
            </AuthContext.Provider>
        </LocalizationProvider>
    );
}

export default App;
